import React from "react";
//MUI
import { Box, Grid, Typography, Button } from "@mui/material";
//画像
import HomeIcon from "@mui/icons-material/Home";
import Core1 from "./material/core1.jpg";
import Core2 from "./material/core2.jpg";
import Core3 from "./material/core3.jpg";
import useMediaQuery from "@mui/material/useMediaQuery";
import { NotoSansJp, QuickSand } from "./TextStyle";
import DocumentMeta from "react-document-meta";
import { useBranch, Navigate } from "./useBranch";

const sections = [
  {
    title: "体操式メニュー",
    description:
      "\t私たちが目指すのは「体操のためだけの体幹」ではありません。サッカーでの切り返し、バスケットのジャンプ、野球のスイング、陸上のスタートダッシュ――あらゆる競技の動きを支える“万能の体幹”です。マット運動に加え、多彩な器具を使って ねじる・支える・弾く の三方向からコアを刺激。軸の安定が生み出すパワー伝達と素早い重心移動は、スポーツ種目を問わずパフォーマンスを底上げします。「どの競技でも通用する身体の芯を手に入れる」――それが、平日【体操式】体幹・体づくり教室のゴールです。",
    image: Core1,
    triangleColor: "#F9E95B",
    borderColor: "#FF6BB5",
    marginTop: "150px",
  },
  {
    title: "少人数制",
    description:
      "1教室最大15名という少人数制だからこそ、コーチの目が一人ひとりに行き届きます。フォームを細かくチェックし、その場で的確なフィードバックを行うことで、正しい動きを身につけながら安全にチャレンジできます。初めての技にも補助を入れて段階的に挑戦できるため、ケガのリスクを最小限に抑えつつ、確かな上達と達成感を重ねられるのが大きな魅力です。",
    image: Core2,
    triangleColor: "#A2D4F5",
    borderColor: "#93C8E5",
    marginTop: "100px",
  },
  {
    title: "成長フィードバック",
    description:
      "月ごとにミニテストを実施して「今どれだけ伸びたか」を見える化します。体操の技で体幹チェックなどを行います。お子さま自身が成長を実感できるのはもちろん、保護者の方も上達の過程を一目で確認できます。次の目標が明確になるから、モチベーションもぐんとアップします。",
    image: Core3,
    triangleColor: "#FBB1C1",
    borderColor: "#ADD578",
    marginTop: "100px",
  },
];

const CoursesFeesTaikan = () => {
  const state = useBranch();
  const isSmartphone = useMediaQuery("(max-width:767px)");

  if (state.status === "loading") return null;
  if (state.status === "notfound") return <Navigate to="/" replace />;
  const branch = state.branch;
  if (!branch.showCoursesFeesTaikan)
    return <Navigate to={`/${branch.id}`} replace />;

  const meta = {
    title: `${branch.roomName}｜平日【体操式】体幹・体づくり教室`,
    description: branch.coursesFeesTaikanDescription,
    canonical: `https://tht-group.co.jp/${branch.id}/coursesfees_taikan`,
    meta: {
      charset: "utf-8",
      name: {
        keywords: [
          ...branch.top.regionKeywords,
          "土日だけ体操教室",
          "体幹トレーニング",
          "体幹 体づくり",
          "体操式メニュー",
          "体操教室",
          "マット運動",
          "跳び箱",
          "鉄棒",
          "トランポリン",
          "柔軟性 強化",
          "姿勢 改善",
          "バランス トレーニング",
          "瞬発力 強化",
          "成長フィードバック",
          "少人数制",
          "子ども 体操",
          "キッズ 体操",
          "小学生 体操",
          "平日 体幹教室",
          "無料体験 レッスン",
        ].join(","),
      },
    },
  };

  return (
    <>
      <DocumentMeta {...meta}>
        <Box sx={{ width: "100vw" }}>
          <Grid
            container
            sx={{
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "100vw" }}>
              <Grid
                container
                direction="column"
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{ width: "100%", mt: isSmartphone ? "40px" : "100px" }}
                >
                  <Grid
                    container
                    direction="column"
                    sx={{
                      justifyContent: "center",
                      alignItems: "center",
                      p: isSmartphone ? "0% 7% 6% 7%" : "0",
                    }}
                  >
                    <Typography
                      component="h1"
                      sx={{
                        color: "green",
                        fontSize: isSmartphone ? "20px" : "35px",
                        fontWeight: "bold",
                        pt: isSmartphone ? "0" : "50px",
                        mb: isSmartphone ? "10px" : "20px",
                        ...NotoSansJp,
                      }}
                    >
                      {branch.roomName}｜平日【体操式】体幹・体づくり教室と料金
                    </Typography>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#333333",
                        mb: "40px",
                      }}
                    >
                      <HomeIcon fontSize="small" />
                      <Typography
                        sx={{ fontSize: isSmartphone ? "14px" : "16px", mx: 1 }}
                      >
                        {">"}
                      </Typography>
                      <Typography
                        sx={{
                          color: "#333333",
                          fontWeight: 500,
                          fontSize: isSmartphone ? "14px" : "16px",
                          ...NotoSansJp,
                        }}
                      >
                        平日【体操式】体幹・体づくり教室と料金
                      </Typography>
                    </Box>

                    <Box sx={{ pt: "30px" }}>
                      <Button
                        component="a"
                        href={branch.freeTrialUrl}
                        sx={{
                          color: "#FFFFFF",
                          bgcolor: "darkgreen",
                          borderRadius: "50px",
                          p: "15px 40px",
                          fontSize: "16px",
                          transition:
                            "background-color 0.3s ease, transform 0.3s ease",
                          ...NotoSansJp,
                          "&:hover": {
                            bgcolor: "#E0B24B",
                            transform: "scale(1.1)",
                            overflow: "hidden",
                            maxWidth: "100%",
                          },
                        }}
                      >
                        無料体験
                      </Button>
                    </Box>
                    <Box
                      sx={{
                        width: isSmartphone ? "100%" : "65%",
                        position: "relative",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: isSmartphone ? "20px" : "35px",
                          fontWeight: "bold",
                          pt: isSmartphone ? "0" : "50px",
                          mb: isSmartphone ? "10px" : "20px",
                          ...NotoSansJp,
                        }}
                      >
                        練習では強化しきれない “体の芯” を、平日で強化
                      </Typography>
                      <Typography>
                        体操式トレーニングで、あらゆるスポーツに応用できる身体操作を習得。
                      </Typography>
                      <Typography>
                        平日は体幹強化と全身の基礎筋力づくりに特化した教室を開講しています。
                      </Typography>
                      <Typography>
                        学校帰りやほかの習い事と両立しやすい短時間集中プログラムだから、効率良く
                        姿勢・バランス・安定感 を高められます。
                      </Typography>
                      {sections.map((section, index) => {
                        const isReverse = index % 2 === 1;

                        return (
                          <Box
                            key={section.title}
                            sx={{
                              display: "flex",
                              flexDirection: {
                                xs: "column",
                                md: isReverse ? "row-reverse" : "row",
                              },
                              mt: isSmartphone ? "0" : `${section.marginTop}`,
                            }}
                          >
                            <Box
                              sx={{
                                position: "relative",
                                width: { xs: "100%", md: "50%" },
                                boxSizing: "border-box",
                                m: isSmartphone
                                  ? "30px 0 0 0"
                                  : isReverse
                                    ? "0 0 0 50px"
                                    : "0 50px 0 0 ",
                              }}
                            >
                              <Box
                                component="img"
                                src={section.image}
                                alt={section.title}
                                sx={{
                                  width: "100%",
                                  borderRadius: "20px",
                                }}
                              />
                            </Box>
                            <Box
                              sx={{
                                width: {
                                  xs: "100%",
                                  md: "50%",
                                },
                                boxSizing: "border-box ",
                                color: "#333333",
                                m: isSmartphone
                                  ? "0"
                                  : isReverse
                                    ? "50px 50px 0 0"
                                    : "50px 0 0 50px",
                              }}
                            >
                              <Typography
                                component="h2"
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: isSmartphone ? "20px" : "35px",
                                  mb: isSmartphone ? 0 : 1,
                                  pt: isSmartphone ? "15px" : 0,
                                  borderBottom: `3px dotted ${section.borderColor}`,
                                  display: "inline-block",
                                  ...NotoSansJp,
                                }}
                              >
                                {section.title}
                              </Typography>
                              <Typography
                                sx={{
                                  pt: isSmartphone ? "10px" : "30px",
                                  fontSize: isSmartphone ? "14px" : "16px",
                                  fontWeight: 500,
                                  ...NotoSansJp,
                                }}
                              >
                                {section.description}
                              </Typography>
                            </Box>
                          </Box>
                        );
                      })}
                    </Box>
                    <Box
                      sx={{
                        width: isSmartphone ? "100%" : "60%",
                        mt: isSmartphone ? "50px" : "150px",
                      }}
                    >
                      <Grid
                        container
                        direction="column"
                        sx={{
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ width: "100%", boxSizing: "border-box" }}>
                          <Grid
                            container
                            direction="column"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <Grid
                              container
                              direction={isSmartphone ? "column" : "row"}
                              justifyContent="center"
                            >
                              {[
                                {
                                  title: "キャンペーン",
                                  lines: [
                                    "年会費0円",
                                    "入会金0円",
                                    "服装自由（Tシャツ約3500円）",
                                    ...(branch.id === "ishikawa"
                                      ? ["MTT進級テスト 869円(毎月)"]
                                      : []),
                                    "月謝 各コースの体験資料をご覧ください",
                                    "※キャンペーンや月謝詳細は体験資料をご確認ください",
                                  ],
                                },
                                {
                                  title: "通常",
                                  lines: [
                                    "年会費0円",
                                    "入会金11000円",
                                    "服装自由（Tシャツ約3500円）",
                                    ...(branch.id === "ishikawa"
                                      ? ["MTT進級テスト 869円(毎月)"]
                                      : []),
                                    "月謝 各コースの体験資料をご覧ください",
                                    "※キャンペーンや月謝詳細は体験資料をご確認ください",
                                  ],
                                },
                              ].map((item) => (
                                <Box
                                  key={item.title}
                                  sx={{
                                    width: isSmartphone ? "100%" : "47%",
                                    bgcolor: "#8ABBD6",
                                    boxSizing: "border-box",
                                    borderRadius: "20px",
                                    p: isSmartphone ? "20px" : "50px",
                                    m: isSmartphone ? "0" : "0 25px 0 0",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: "#FFFFFF",
                                      fontSize: isSmartphone ? "20px" : "35px",
                                      fontWeight: 700,
                                      textAlign: "center",
                                      ...NotoSansJp,
                                    }}
                                  >
                                    {item.title}
                                  </Typography>
                                  <Grid
                                    container
                                    direction={isSmartphone ? "column" : "row"}
                                    alignItems="center"
                                    justifyContent="center"
                                    sx={{ py: "30px", px: "10px" }}
                                  >
                                    <Typography
                                      sx={{
                                        color: "#FFFFFF",
                                        fontWeight: "bold",
                                        fontSize: isSmartphone
                                          ? "18px"
                                          : "20px",
                                        ...NotoSansJp,
                                        whiteSpace: "pre-line",
                                      }}
                                    >
                                      {item.lines.join("\n")}
                                    </Typography>
                                  </Grid>
                                </Box>
                              ))}
                            </Grid>
                            {branch.weekdayCourses.map((course) => (
                              <React.Fragment key={course.label}>
                                <Typography
                                  component="h2"
                                  sx={{
                                    color: course.titleColor,
                                    fontSize: isSmartphone ? "25px" : "35px",
                                    fontWeight: 700,
                                    mt: isSmartphone ? "30px" : "100px",
                                    mb: "20px",
                                    textAlign: "center",
                                  }}
                                >
                                  {course.label}
                                </Typography>

                                <Grid container justifyContent="center">
                                  {course.items.map((content) => (
                                    <Grid
                                      item
                                      xs={12}
                                      md={6}
                                      key={content.number}
                                    >
                                      <Box
                                        sx={{
                                          bgcolor: course.boxBg,
                                          borderRadius: "20px",
                                          p: isSmartphone
                                            ? "30px 20px"
                                            : "50px 50px 30px",
                                          textAlign: "center",
                                          m:
                                            content.number === 1
                                              ? isSmartphone
                                                ? "0"
                                                : "0 25px 0 0"
                                              : isSmartphone
                                                ? "30px 0 0 0"
                                                : "0 0 0 25px",
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            width: isSmartphone ? 74 : 90,
                                            height: isSmartphone ? 74 : 90,
                                            borderRadius: "50%",
                                            backgroundColor: "#fff",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            mx: "auto",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              color: course.titleColor,
                                              fontSize: isSmartphone
                                                ? "30px"
                                                : "50px",
                                              fontWeight: "bold",
                                              ...QuickSand,
                                            }}
                                          >
                                            {content.number}
                                          </Typography>
                                        </Box>

                                        <Typography
                                          sx={{
                                            fontSize: isSmartphone ? 14 : 16,
                                            color: "#fff",
                                            fontWeight: 500,
                                            m: "5px 0 20px 0",
                                            ...NotoSansJp,
                                          }}
                                        >
                                          対象：{content.target}
                                        </Typography>

                                        <Typography
                                          sx={{
                                            fontSize: isSmartphone ? 16 : 20,
                                            color: "#fff",
                                            fontWeight: 500,
                                            ...NotoSansJp,
                                          }}
                                        >
                                          {content.weektime}
                                        </Typography>
                                        <Typography
                                          sx={{
                                            fontSize: isSmartphone ? 16 : 20,
                                            color: "#fff",
                                            fontWeight: 500,
                                            ...NotoSansJp,
                                          }}
                                        >
                                          {content.holitime}
                                        </Typography>

                                        <Grid
                                          container
                                          direction={
                                            isSmartphone ? "column" : "row"
                                          }
                                          alignItems="center"
                                          justifyContent="center"
                                          sx={{
                                            m: "30px 0 33px 0",
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              color: "#fff",
                                              fontWeight: "bold",
                                              fontSize: isSmartphone ? 18 : 20,
                                              whiteSpace: "nowrap",
                                              ...NotoSansJp,
                                            }}
                                          >
                                            {content.count1}
                                          </Typography>
                                          <Box
                                            sx={{
                                              borderTop: `2px dotted ${course.dotColor}`,
                                              mx: 2,
                                              flexGrow: 1,
                                            }}
                                          />
                                          <Typography
                                            sx={{
                                              color: "#fff",
                                              fontWeight: 500,
                                              fontSize: isSmartphone ? 14 : 18,
                                              whiteSpace: "nowrap",
                                              ...NotoSansJp,
                                            }}
                                          >
                                            {content.price1}
                                          </Typography>
                                        </Grid>

                                        {content.explanation && (
                                          <Typography
                                            sx={{
                                              fontSize: 14,
                                              color: "#fff",
                                              mt: 2,
                                              textAlign: "left",
                                              fontWeight: 700,
                                              ...NotoSansJp,
                                            }}
                                          >
                                            {content.explanation}
                                          </Typography>
                                        )}
                                      </Box>
                                    </Grid>
                                  ))}
                                </Grid>
                              </React.Fragment>
                            ))}
                          </Grid>
                        </Box>
                      </Grid>
                    </Box>

                    <Box sx={{ pt: "30px" }}>
                      <Button
                        component="a"
                        href={branch.freeTrialUrl}
                        sx={{
                          color: "#FFFFFF",
                          bgcolor: "darkgreen",
                          borderRadius: "50px",
                          p: "15px 40px",
                          fontSize: "16px",
                          transition:
                            "background-color 0.3s ease, transform 0.3s ease",
                          ...NotoSansJp,
                          "&:hover": {
                            bgcolor: "#E0B24B",
                            transform: "scale(1.1)",
                            overflow: "hidden",
                            maxWidth: "100%",
                          },
                        }}
                      >
                        無料体験
                      </Button>
                    </Box>
                  </Grid>
                </Box>
              </Grid>
            </Box>
          </Grid>
        </Box>
      </DocumentMeta>
    </>
  );
};

export default CoursesFeesTaikan;
